// extracted by mini-css-extract-plugin
export default {"main":"VolumenHorasPackSelector_main__tvFgb"};